import './App.scss';
import 'remixicon/fonts/remixicon.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import RoutesContainer from './routes/Routes';



function App() {
  return (
    <div className="App">
      <RoutesContainer/>
    </div>
  );
}

export default App;
